export const Filter = {
  SnoozedOnly: "snoozedOnly" as const,
  Urgency: "urgency" as const,
  Groups: "groups" as const,
  SubTypes: "subTypes" as const,
  DeadlineTypes: "deadlineTypes" as const,
}

